export default __webpack_public_path__ + "static/media/minus_black.b07a2992.svg";